export default "__VITE_ASSET___3pKOeDA__"